import React from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BottomSlideTransition from 'pages/ShareYourLight/components/BottomSlideTransition';

interface CommonModalProps {
  open: boolean;
  onClose: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  children: React.ReactNode;
  paperSx?: object;
  contentSx?: object;
  showClose?: boolean;
  title?: React.ReactElement
  avoidLeftTitleMargin?: boolean;
}

function CommonModal({
  open,
  onClose,
  maxWidth = 'md',
  fullWidth = true,
  children,
  paperSx = {},
  contentSx = {},
  showClose = true,
  title,
  avoidLeftTitleMargin,
}: CommonModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      TransitionComponent={BottomSlideTransition}
      PaperProps={{
        sx: {
          background: '#171B26',
          borderRadius: 3,
          boxShadow: '0 0 40px 0 #000',
          p: 0,
          overflow: 'visible',
          ...paperSx,
        },
      }}
    >
      <Box sx={{ pt: 1.5, px: 1.5, zIndex: 2 }} display='flex' alignItems='flex-start' justifyContent='space-between' gap={1}>
        <Box flex={1} ml={avoidLeftTitleMargin ? 0 : 5.25}>
          {title}
        </Box>
        {showClose && (
        <IconButton onClick={onClose} size='small' sx={{ color: '#fff' }}>
          <CloseIcon />
        </IconButton>
        )}
      </Box>
      <DialogContent sx={{ px: 1.5, pb: 1.5, pt: 0, ...contentSx }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default CommonModal;
